import classNames from 'classnames';

import { InnerContentScrollbars } from '../../../components/layout/InnerContentScrollbars';
import { FlexCol } from '../../../components/layout/layoutElements';
import { useLayoutElementsStyles } from '../../../components/layout/layoutElements.styles';
import DarkSimpleButtonTheme from '../../../styles/DarkSimpleButtonTheme';
import { AdminConsoleTitleContainer } from '../components/AdminConsoleTitle';
import AdminConsoleHeader from './AdminConsoleHeader';
import AdminConsoleMenu from './AdminConsoleMenu';

export default function AdminConsoleTemplate({ title, children }) {
  const { styles: layoutStyles } = useLayoutElementsStyles();
  return (
    <DarkSimpleButtonTheme>
      <div className="AdminConsoleTemplate">
        <div className="AdminConsoleTemplate-Content">
          <AdminConsoleHeader />
          <AdminConsoleMenu />
          <div className="AdminConsoleTemplate-InnerContent">
            <FlexCol className={classNames(layoutStyles.flex1, 'gap-norm')}>
              {title && (
                <AdminConsoleTitleContainer>{title}</AdminConsoleTitleContainer>
              )}
              <FlexCol
                className={classNames(
                  layoutStyles.flex1,
                  'AdminConsoleTemplate--Scrollable'
                )}
              >
                <InnerContentScrollbars>{children}</InnerContentScrollbars>
              </FlexCol>
            </FlexCol>
          </div>
        </div>
      </div>
    </DarkSimpleButtonTheme>
  );
}
